import { Injectable, Optional } from "@angular/core";
import { NavigationStart, Router } from "@angular/router";
import { filter } from "rxjs/operators";

/**
 * 全局清理 ng-zorro tooltip 残留 overlay。
 * 典型场景：hover 出 tooltip 后立刻点击跳转/打开详情，CDK overlay 未销毁，飘到下一页。
 *
 * 引入 FantasyNgzorroModule 后自动生效，也可手动注入调用 clearStuckTooltips()。
 */
@Injectable({ providedIn: "root" })
export class HdOverlayCleanupService {
  private started = false;

  constructor(@Optional() private router: Router) {
    this.start();
  }

  /** 启动全局监听（幂等） */
  start(): void {
    if (this.started || typeof document === "undefined") {
      return;
    }
    this.started = true;

    // 任意按下即清：覆盖跳路由、开抽屉/弹窗等不走 Navigation 的场景
    document.addEventListener(
      "mousedown",
      () => this.clearStuckTooltips(),
      true,
    );

    if (this.router) {
      this.router.events
        .pipe(filter((e) => e instanceof NavigationStart))
        .subscribe(() => this.clearStuckTooltips());
    }
  }

  /** 清理残留在 body 上的 ant-tooltip overlay */
  clearStuckTooltips(): void {
    if (typeof document === "undefined") {
      return;
    }
    const tooltips = document.querySelectorAll(
      ".cdk-overlay-container .ant-tooltip",
    );
    tooltips.forEach((el) => {
      const pane = el.closest(".cdk-overlay-pane") as HTMLElement | null;
      if (pane && pane.parentNode) {
        pane.parentNode.removeChild(pane);
      }
    });
  }
}
